import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";

import Platform from "nexia_mobile/platform";
import LocalSettings, {
  AUTH_LOCKOUT_MINUTES,
} from "nexia_mobile/models/local_settings";
import { clearHistoryAndPush } from "nexia_mobile/history";
import batchReactUpdates from "nexia_mobile/batchReactUpdates";

let isAuthenticating = false;

Dispatch.on("VALIDATE_FINGERPRINT", () => {
  if (isAuthenticating) {
    // only bring up the dialog once
    return;
  }
  Platform.isFingerprintAuthAvailable()
    .then((available) => {
      if (!available) {
        return;
      }
      isAuthenticating = true;
      Platform.authenticateWithFingerprint()
        .then((result) => {
          isAuthenticating = false;
          if (result.success) {
            LocalSettings.clearFailedAuthAttempts();
            Platform.sendGoogleAnalyticsEvent(
              "login",
              "fingerprint_auth",
              "success"
            );
            batchReactUpdates(() => {
              setValueAtPath("appState.userAuthenticated", true);
              clearHistoryAndPush("/app");
            });
          } else {
            if (result.wasIntentionallyCancelled) {
              setValueAtPath("userCancelledFingerprint", true);
              return;
            }
            // Don't count a failure when "Cancel" is pressed
            LocalSettings.recordFailedAuthAttempt();
            Platform.sendGoogleAnalyticsEvent(
              "login",
              "fingerprint_auth",
              "error"
            );
            setValueAtPath(
              "isAuthAttemptLockedOut",
              LocalSettings.isAuthAttemptLockedOut()
            );
            if (Store.isAuthAttemptLockedOut) {
              setTimeout(
                () => Dispatch("AUTH_LOCKOUT_ENDED"),
                AUTH_LOCKOUT_MINUTES * 60 * 1000
              );
            }
            // Rather than explicitly going to the validate-pin view here, just assume
            // the view is underneath the fingerprint dialog. If not, we probably
            // want to be at whatever other page (like the dashboard) anyway.
          }
        })
        .catch(() => {
          // Treat a network error as the user closing the dialog.
          isAuthenticating = false;
          setValueAtPath("userCancelledFingerprint", true);
        });
    })
    .catch(() => {
      // ignore platform bridge error
    });
});

Dispatch.on("CANCEL_FINGERPRINT", () => {
  if (isAuthenticating) {
    Platform.cancelFingerprintAuthentication();
  }
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/fingerprint.js